import { makeStyles } from '@material-ui/core/styles'

export default makeStyles({
  mountpointTooltip: {
    '&.leaflet-tooltip': {
      width: '40px !important',
      // height: '25px !important',
      background: 'transparent !important',
      border: 'none !important',
      color: 'white !important',
      fontSize: '12px !important',
      boxShadow: 'none !important',
      padding: '0 !important',
      '&::before': {
        display: 'none !important',
      },
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sourceLineTooltip: {
    '&.leaflet-tooltip': {
      // border: 'none !important',
      // boxShadow: 'none !important',
      // background: 'transparent !important',
      '&::before': {
        display: 'none !important',
      },
    },
  },
  userIcon: {
    width: 20,
    height: 20,
    // background: '#01cb09',
    border: '2px solid snow',
    borderRadius: '50%',
  },
  checkbox: {
    '& .MuiCheckbox-root': {
      padding: 0,
      margin: '0 5px',
    },
    '& .MuiTypography-body1': {
      fontSize: 14,
    },
  },
  legendItem: {
    height: 30,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
})
